import {
  GET_USER_TAGS_START,
  GET_USER_TAGS_SUCCESS,
  GET_USER_TAGS_FAIL,
} from '../constants/actionTypes';

const initialState = {
  data: null,
  error: null,
  state: 'NONE',
};

const userTagsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_USER_TAGS_START:
      return { state: 'PENDING', data: null, error: null };
    case GET_USER_TAGS_SUCCESS:
      return { state: 'SUCCESS', data: action.payload };
    case GET_USER_TAGS_FAIL:
      return { state: 'FAIL', data: null, error: action.payload };
    default:
      return state;
  }
};

export default userTagsReducer;
